window.BundleCart = (() => {

    async function addBundle() {

        const items = BundleState.getItems();

        if (items.length !== 3) {
            alert("Please select exactly 3 items.");
            return;
        }

        // TODO: Replace these with dynamic Liquid values
        const bundle = {
            id: "vtP0",
            deal: "0YaR",
            bid: "AHHr",
            version: "7e07da69-dd2c-40c0-a38f-ac3fbe00ca69"
        };

        const cartItems = items.map((item, index) => {

            const isMain = index === items.length - 1;

            const bundleData = {
                id: bundle.id,
                deal: bundle.deal,
                v: bundle.version
            };

            if (isMain) {
                bundleData.main = true;
                bundleData.bid = bundle.bid;
                bundleData.pp = Number(item.productId);
            } else {
                bundleData.collectionBreaksProduct = true;
            }

            return {
                id: Number(item.variantId),
                quantity: 1,
                properties: {
                    "__kaching_bundles": JSON.stringify(bundleData)
                }
            };

        });

        try {

            const response = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    items: cartItems,
                    sections: ["cart-icon-bubble"],
                    sections_url: window.location.pathname
                })
            });

            const parsedState = await response.json();

            if (!response.ok) {
                throw parsedState;
            }

            BundleState.clear();
            BundleUI.render();

            //
            // Update the header cart icon count.
            // The cart-icon-bubble section HTML is wrapped in <div id="shopify-section-cart-icon-bubble">,
            // so we must read the count markup from THAT wrapper (or ".shopify-section") — NOT from
            // "#cart-icon-bubble", which is the <a> in the header and is not present inside the section.
            //
            const setBubble = (sectionHTML) => {
                const currentBubble = document.querySelector("#cart-icon-bubble");
                if (!currentBubble || !sectionHTML) return;
                const doc = new DOMParser().parseFromString(sectionHTML, "text/html");
                const src =
                    doc.querySelector("#shopify-section-cart-icon-bubble") ||
                    doc.querySelector(".shopify-section") ||
                    doc.querySelector("#cart-icon-bubble") ||
                    doc.body;
                if (src) currentBubble.innerHTML = src.innerHTML;
            };

            let bubbleHTML = parsedState.sections && parsedState.sections["cart-icon-bubble"];
            if (!bubbleHTML) {
                try {
                    const r = await fetch("/?sections=cart-icon-bubble");
                    bubbleHTML = (await r.json())["cart-icon-bubble"];
                } catch (e) {}
            }
            setBubble(bubbleHTML);

            //
            // Let the theme and the cart-drawer app (UpCart) know the cart changed so the
            // drawer/count stay in sync, regardless of which cart UI the store uses.
            //
            try { document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true })); } catch (e) {}
            if (typeof window.upcartRefreshCart === "function") { try { window.upcartRefreshCart(); } catch (e) {} }
            if (typeof window.upcartOpenCart === "function") { try { window.upcartOpenCart(); } catch (e) {} }

        } catch (error) {

            console.error(error);
            alert("Something went wrong while adding your bundle.");

        }

    }

    return {
        addBundle
    };

})();
